<template>
  <div class="header-controls">
  <div></div>
    <div class="logo">
      <div>
        <img class="logo__image" alt="medtech - logo" src="@/assets/logo.svg"/>
      </div>
      <div>
        <span class="logo__wrapper">Medtech - admin</span>
      </div>
    </div>

    <div class="header-controls__right">
      <profile-avatar-button></profile-avatar-button>
    </div>
  </div>
</template>

<script>
import ProfileAvatarButton from './elements/ProfileAvatarButton'

export default {
  name: 'TheHeader',
  components: { ProfileAvatarButton }
}
</script>

<style scoped lang="scss">
.logo {
  display: flex;
  justify-content: center;
  align-items: center;

  &__wrapper {
    overflow: hidden;
    display: block;
    position: relative;

    padding: 0 15px;
    color: #fff;
    font-weight: 600;
  }

  &__image {
    height: 40px;
  }
}

.header-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;

}
</style>
